export const downloadExcel = async (
  excelUrl?: string | null,
  fileName = "download.xlsx",
) => {
  if (!excelUrl) {
    return;
  }

  const link = document.createElement("a");
  link.href = excelUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};